export default __webpack_public_path__ + "static/media/RequestService.aa077176.svg";